import {Component, Input} from "@angular/core";

@Component({
    selector: "fui-inline-information",
    styleUrls: ["./inline-information.component.scss"],
    templateUrl: "./inline-information.component.html"
})
export class FUIInlineInformationComponent {
    @Input() title: string;
    @Input() titleParams: any = {};
    @Input() message: string;
    @Input() messageParams: any = {};
}
